// react imports
import { useHistory } from "react-router";

// common imports
import ArrowRight from "common/svg/ArrowRight";
import ArrowLeft from "common/svg/ArrowLeft";

// styled-components imports
import Container from "./styled-components/Container";
import Content from "./styled-components/Content";
import PageIndicator from "./styled-components/PageIndicator";
import PaginationHeader from "./styled-components/PaginationHeader";
import RestartButton from "./styled-components/RestartButton";
import Title from "./styled-components/Title";

import { Sector } from "features/result/constants/sectors";
import Navigation from "./styled-components/Navigation";
import NavigationButton from "./styled-components/NavigationButton";
import { trackCalculationBegins } from "features/cookie-banner/gtm-functions";

interface PaginationProps {
  children: React.ReactNode;
  sector: Sector;
  page: number;
  total: number;
  handleNext(): void;
  handleBack(): void;
}

function Pagination({
  sector,
  page,
  total,
  handleNext,
  handleBack,
  children,
}: PaginationProps) {
  const history = useHistory();
  function handleRestart() {
    trackCalculationBegins();
    history.push("/calculator");
  }
  return (
    <Container>
      <PaginationHeader>
        <PageIndicator color={sector.color}>
          {page}/{total}
        </PageIndicator>
        <Title>{sector.title}</Title>
      </PaginationHeader>
      <Content>{children}</Content>
      <Navigation>
        {page > 1 && (
          <NavigationButton onClick={handleBack}>
            <ArrowLeft size={25} />
            &nbsp;Atrás
          </NavigationButton>
        )}
        {page < total && (
          <NavigationButton onClick={handleNext}>
            Siguiente&nbsp;
            <ArrowRight size={25} />
          </NavigationButton>
        )}
        {page === total && (
          <RestartButton onClick={handleRestart}>
            Repetir calculadora
          </RestartButton>
        )}
      </Navigation>
    </Container>
  );
}

export default Pagination;
